import { useAppDisplayModeContext } from '@archipro-design/aria';
import InfoPageMobile from '@modules/professional/page/info/InfoPage.mobile';
import InfoPageDesktop from '@modules/professional/page/info/InfoPage.desktop';

const InfoPage = () => {
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return <InfoPageMobile />;
    }

    return <InfoPageDesktop />;
};

export default InfoPage;
